
















































































import Vue from "vue";
import Component from "vue-class-component";
import {AdditionalIngredientsGroup, IAdditionalIngredientsGroup} from "@/data/AdditionalIngredientsGroup";
import {Prop, Watch} from "vue-property-decorator";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {additionalIngredientsGroupsModule, providersModule} from "@/store/store";
import {CollectionSyncedList} from "@/common/vuex/FirestoreCollectionsModule";
import {TableHeader} from "@/plugins/vuetify";
import {i18n} from "@/plugins/i18n";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import Messages from "@/components/Messages.vue";
import {addDocument, deleteDocument, FirestoreObjectOptions} from "@/common/js/firestore-utils";

@Component({
    components: {ConfirmDialog, ValidationProvider, ValidationObserver}
})
export default class AdditionalIngredientsGroupsView extends Vue {

    headers: TableHeader[] = [
        {value: "name", text: i18n.t("views.additional-ingredients-groups.list.name") as string},
        {
            value: "ingredients",
            text: i18n.t("views.additional-ingredients-groups.list.ingredients") as string,
            sortable: false
        },
        {
            value: "actions",
            text: i18n.t("views.additional-ingredients-groups.list.actions") as string,
            sortable: false
        },
    ];

    filter: string = "";
    selectedProviderId: string = "";

    loadingDuplicate: boolean = false;

    @Prop({required: true})
    readonly providerId!: string;

    get groups(): CollectionSyncedList<IAdditionalIngredientsGroup> {
        return additionalIngredientsGroupsModule.collections[this.providerId];
    }

    get providersModule() {
        return providersModule;
    }

    get additionalIngredientGroupOptions(): FirestoreObjectOptions {
        return {
            collectionPath: `/providers/${this.providerId}/additional-ingredients-groups`
        };
    }

    get messages(): Messages {
        return this.$inject("messages");
    }

    stopGroupsSync?: () => void;
    stopProvidersSync!: () => void;

    beforeMount() {
        this.stopProvidersSync = providersModule.syncProviders();
    }

    destroyed() {
        this.stopProvidersSync();
        this.stopGroupsSync?.();
    }

    @Watch("providerId", {immediate: true})
    onProviderId() {
        this.selectedProviderId = this.providerId;

        this.stopGroupsSync?.();
        this.stopGroupsSync = additionalIngredientsGroupsModule.syncGroups(this.providerId);
    }

    @Watch("selectedProviderId")
    onSelectedProviderId() {
        this.changeProvider(this.selectedProviderId);
    }

    async changeProvider(providerId: string) {
        if (providerId !== this.providerId && providersModule.providers.find(provider => provider.id === providerId))
            await this.$router.push({name: "additional-ingredients-groups", params: {providerId: providerId}});
    }

    async deleteGroup(groupId: string) {
        await deleteDocument(groupId, this.additionalIngredientGroupOptions);
        await this.messages.showSuccess(this.$t("views.additional-ingredients-groups.messages.group-deleted") as string);
    }

    async deleteError(error: any) {
        console.error(error);
        await this.messages.showError(this.$t("views.additional-ingredients-groups.messages.failed-to-delete-group") as string);
    }

    async duplicateGroup(group: IAdditionalIngredientsGroup) {
        this.loadingDuplicate = true;

        const groupDuplicate = AdditionalIngredientsGroup.copy(group, {});

        for (let i = 1; ; i++) {
            const name = `${groupDuplicate.name} (${i})`;
            if (!this.groups.list.find(group => group.name === name)) {
                groupDuplicate.name = name;
                break;
            }
        }

        try {
            await addDocument(groupDuplicate, this.additionalIngredientGroupOptions);
            await this.messages.showSuccess(this.$t("views.additional-ingredients-groups.messages.group-duplicated") as string);
        } catch (error) {
            console.error(error);
            await this.messages.showError(this.$t("views.additional-ingredients-groups.messages.failed-to-duplicate-group") as string);
        }

        this.loadingDuplicate = false;
    }

}
